import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-primary-title',
  templateUrl: './primary-title.component.html',
  styleUrls: ['./primary-title.component.less']
})
export class PrimaryTitleComponent implements OnInit {

  @Input() public title: string = '';
  @Input() public subTitle: string = '';
  @Input() public hasCarrisLogo: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
